import { motion } from "framer-motion";

export default function ChapterHeading({ number, title, kicker, testid, total = "05" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="mb-12 sm:mb-16"
      data-testid={testid}
    >
      <div className="flex items-center gap-5 mb-5">
        <span className="font-mono text-[11px] uppercase tracking-[0.35em] text-terracotta whitespace-nowrap">
          Capitolo {number}
        </span>
        <span className="h-px flex-1 bg-sand" />
        <span className="font-mono text-[11px] tracking-[0.35em] text-clay">{number}/{total}</span>
      </div>
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2D2A26]">
        {title}
      </h2>
      {kicker && (
        <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-[#5C564E]">
          {kicker}
        </p>
      )}
    </motion.div>
  );
}
